import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class GivenByColumn extends Column {
    title = 'performance.feedbackColumns.givenBy';
    property = 'creator';
    sortField = 'creator.firstName';
    sortable = true;
    type: CellDisplay = CellDisplay.avatarOnly;
}
